const VRSTA_OPERATERA = {
  IZ_RH: 1,
  IZ_RH_ISKLJUCENI: 2,
  IZVAN_EU: 3,
};

const VRSTA_ZAHTJEVA = {
  REGISTRACIJA: "REGISTRACIJA",
  ISKLJUCENJE: "ISKLJUCENJE",
};

const TIP_INFO_PORUKE = {
  SUCCESS: 1,
  ERROR: 2,
};

const OSLOBODJEN_OD_IZVJESCIVANJA = {
  DA: 1,
  NE: 2,
};

const VRSTA_IDENTIFIKATORA = {
  TIN: 3,
};

const TIP_IZVJESCA = {
  IZVAN_RH: 1,
  IZ_RH: 2,
};

export {
  VRSTA_OPERATERA,
  VRSTA_ZAHTJEVA,
  TIP_INFO_PORUKE,
  OSLOBODJEN_OD_IZVJESCIVANJA,
  VRSTA_IDENTIFIKATORA,
  TIP_IZVJESCA,
};
